import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "token";

export const saveToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getTokenExpiration = () => {
  const token = getToken();
  if (!token) return null;
  const decoded = jwtDecode(token);
  return decoded.exp * 1000; // convert to ms
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  window.location.href = "/auth/login";
};

export const isTokenExpired = () => {
  const expiration = getTokenExpiration();
  if (!expiration) return true;
  return Date.now() > expiration;
};
